import React, { useState } from 'react'
import { Table, Icon, Uploader, Message, ButtonGroup, IconButton, Whisper, Tooltip } from 'rsuite'
import { isEmpty } from 'lodash-es'
import { isRequiredFiled } from '../../../utils/ValidatorUtils'

export default function ManageDurableArticlesAttch({
  schema,
  loading,
  Controller,
  register,
  control,
  errors,
  setValue,
  getValues,
  setError,
  clearErrors,
  onPreview = () => {},
  onDownload = () => {},
  isEnableUpload,
  isFileRequired,
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table

  const DEL_KEY = 'delAttchIds'

  const [formSchema, setFormSchema] = useState(schema)
  const [delIds, setDelIds] = useState([])

  const onDelFile = async (fileObj) => {
    let dels = [...delIds, fileObj.fileId]
    setDelIds(dels)

    setValue(DEL_KEY, dels)
  }

  return (
    <>
      {formSchema && (
        <>
          <p>เอกสารประกอบการพิจารณา</p>

          {isEnableUpload && (
            <Message
              style={{ marginTop: 10, marginBottom: 10 }}
              showIcon
              type="info"
              description="ชนิดที่รองรับ : .jpg, .jpeg, .png, .pdf, .doc, .docx  ขนาดไฟล์ไม่เกิน 5 MB"
            />
          )}

          {isFileRequired && (
            <Message
              style={{ marginTop: 10, marginBottom: 10 }}
              showIcon
              type="error"
              description="กรุณาแนบไฟล์ เอกสารประกอบการพิจารณาที่มี * ให้ครบ"
            />
          )}

          <Controller name={DEL_KEY} control={control} defaultValue={[]} />

          <Table autoHeight height={300} wordWrap bordered data={formSchema}>
            <Column width={90} align="center" fixed>
              <HeaderCell>ไฟล์ที่</HeaderCell>
              <Cell>
                {(_, index) => {
                  return index + 1
                }}
              </Cell>
            </Column>

            <Column width={500} flexGrow={1}>
              <HeaderCell>ประเภทไฟล์</HeaderCell>
              <Cell>
                {(rowData, index) => {
                  return isRequiredFiled(rowData.isRequired, rowData.label)
                }}
              </Cell>
            </Column>

            <Column width={150} align="center" fixed="right">
              <HeaderCell>เอกสารประกอบ</HeaderCell>
              <Cell>
                {(rowData, index) => {
                  if (
                    !delIds?.includes(rowData.fileId) &&
                    (rowData.filePath || rowData.id == 'asset_1')
                  ) {
                    return (
                      <ButtonGroup>
                        <IconButton
                          appearance="ghost"
                          icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                          onClick={(e) => onPreview(rowData)}
                          disabled={loading}
                        />
                        <IconButton
                          appearance="ghost"
                          icon={<Icon icon="download" className="bt-gost-icon-none-radius" />}
                          onClick={(e) => onDownload(rowData)}
                          disabled={loading}
                        />
                        {!rowData?.disabled && (
                          <IconButton
                            appearance="ghost"
                            className="rs-btn-ghost-cancel"
                            icon={<Icon icon="trash-o" className="bt-gost-icon-radius-cancel" />}
                            onClick={(e) => onDelFile(rowData, index)}
                            disabled={loading}
                          />
                        )}
                      </ButtonGroup>
                    )
                  }
                }}
              </Cell>
            </Column>

            {isEnableUpload && (
              <Column width={250} align="center">
                <HeaderCell>แนบเอกสาร</HeaderCell>
                <Cell>
                  {(rowData, index) => {
                    // if (rowData.filePath) {
                    //   return (
                    //     <ButtonGroup>
                    //       <IconButton
                    //         appearance="ghost"
                    //         icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                    //         onClick={(e) => onPreview(rowData)}
                    //         disabled={loading}
                    //       />
                    //       <IconButton
                    //         appearance="ghost"
                    //         icon={<Icon icon="download" className="bt-gost-icon-none-radius" />}
                    //         onClick={(e) => onDownload(rowData)}
                    //         disabled={loading}
                    //       />
                    //     </ButtonGroup>
                    //   )
                    // }
                    if (rowData?.disabled) {
                      return ''
                    } else {
                      return (
                        <Controller
                          name={rowData.name}
                          control={control}
                          defaultValue={!isEmpty(rowData.value) ? [rowData.value] : undefined}
                          // rules={isValidators(attachmentSchema.validators)}
                          render={(props) => {
                            if (props.value) {
                              return (
                                <div
                                  style={{
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  <p>{props?.value[0]?.name || 'file name'}</p>

                                  <IconButton
                                    appearance="link"
                                    //className="rs-btn-ghost-cancel"
                                    icon={<Icon icon="close" style={{ color: 'gray' }} />}
                                    onClick={(e) => {
                                      props.onChange()
                                    }}
                                  />
                                </div>
                              )
                            } else {
                              return (
                                <Uploader
                                  accept=".jpg, .jpeg, .png, .pdf, .doc, .docx"
                                  draggable
                                  autoUpload={false}
                                  multiple={false}
                                  listType="picture"
                                  fileList={props.value || []}
                                  onChange={(fileList) => {
                                    if (isEmpty(fileList)) {
                                      props.onChange(undefined)
                                    } else {
                                      let files = []
                                      files.push(fileList[fileList.length - 1])
                                      props.onChange(files)
                                    }
                                  }}
                                >
                                  <button className="upload__button" style={{ marginTop: 0 }}>
                                    <Icon icon="upload" size="lg" />
                                  </button>
                                </Uploader>
                              )
                            }
                          }}
                        />
                      )
                    }
                  }}
                </Cell>
              </Column>
            )}

            {/* <Column width={150} align="center" fixed="right">
              <HeaderCell>ดาวนโหลดไฟล์</HeaderCell>
              <Cell>
                {(rowData, index) => {
                  if (rowData?.filePath) {
                    let _rowData = {
                      path: rowData.filePath,
                      ...rowData,
                    }

                    let fileName = _rowData.path.split('/')[2]
                    console.log('fileName', fileName)
                    return (
                      <ButtonGroup>
                        <Whisper
                          placement="bottom"
                          speaker={<Tooltip style={{ fontSize: 15 }}>{fileName}</Tooltip>}
                        >
                          <IconButton
                            appearance="ghost"
                            icon={<Icon icon="download" className="bt-gost-icon-none-radius" />}
                            onClick={(e) => onDownload(_rowData)}
                            disabled={!_rowData?.path}
                          />
                        </Whisper>
                      </ButtonGroup>
                    )
                  }
                }}
              </Cell>
            </Column> */}
          </Table>
        </>
      )}
    </>
  )
}
